import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OndMarketingDataService } from '@fcom/ond-marketing-landing-core/services/ond-marketing-data.service';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { ModalComponent } from '@fcom/ui-components/components/modal/modal.component';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { UiTranslateModule } from '@fcom/ui-translate';

import { DestinationSearchService } from './services/destination-search.service';
import { AmDestinationService } from './services/am-destination.service';
import { AmDestinationContinueModalComponent } from './am-destination-continue-modal/am-destination-continue-modal.component';
@NgModule({
  imports: [CommonModule, IconComponent, ModalComponent, ComponentsModule, UiTranslateModule],
  declarations: [AmDestinationContinueModalComponent],
  exports: [AmDestinationContinueModalComponent],
  providers: [DestinationSearchService, OndMarketingDataService, AmDestinationService],
})
export class DestinationSearchModule {}
